import React, { useEffect, useState } from "react";
import { GET_USER_LEAVE_CRED_DATA } from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface leaveRequestByIdProps {
    id : number;
    days_on_leave : number; 
    leave_type : string;
    leave_dates : string;
    status : string;
}

interface empleaveCreditsProps {
    emp_id : number;
    fullname : string;
    total_leave : number;
    earned_vl : number;
    total_vl : number;
    total_sl : number;
    used_vl : number;
    used_sl : number;
    remaining_vl : number;
    remaining_sl : number;
}

// interface userLeaveCredProps {
//     vl_cred : number;
//     sl_cred : number;
//     converted_leave_cred : number;
//     used_vl : number;
//     used_sl : number;
//     leave_data : leaveRequestByIdProps[];
// }

interface EmpLeaveDetailsProps {
    account_id : number;
    full_name : string;
}

const EmpLeaveDetails: React.FC<EmpLeaveDetailsProps> = ({account_id, full_name}) => {
    const [leaveData, setLeaveData] = useState<leaveRequestByIdProps[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const formatDate = (dateString: string | undefined): string => {
        if(!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    useEffect(()=>{
        const loadLeaveCred = async() => {
            try{
                const cred_res = await api.get(GET_USER_LEAVE_CRED_DATA+account_id,{
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const leave_data = cred_res.data as {leave_cred : empleaveCreditsProps[], annual_leave_req : leaveRequestByIdProps[]};
                setLeaveData(leave_data.annual_leave_req);
                setLoading(false);
            }catch(e){
                const error = e as AxiosError;
                if(error.response?.status === 401){
                    alert('login session expired!')
                }else{
                    alert('Something went wrong!')
                }
            }
        }
        loadLeaveCred();
    },[account_id]);
        
    return (
        <div className="max-w-[56rem] min-w-[56rem] min-h-96">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="my-4">
                <h1 className="uppercase font-semibold text-gray-700">
                    {full_name}
                </h1>
            </div>
            <div className="table-container h-full shadow">
                <table className="w-full h-full border">
                    <thead className="table-fixed-header border">
                        <tr className="bg-gray-100">
                            <th className='table-headers font-medium'>#</th>
                            <th className='table-headers font-medium max-w-14'>No. of Days</th>
                            <th className='table-headers font-medium'>Leave type</th>
                            <th className='table-headers font-medium max-w-9'>Date/s on leave</th>
                            <th className='table-headers font-medium max-w-10'>Status</th>
                            {/* <th className='table-headers font-medium'>Action</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {leaveData && leaveData ? leaveData.map((data, index) => (
                            <tr className="hover:bg-gray-300">
                                <td className='table-body px-2'>{index + 1}</td>
                                <td className='table-body px-2'>{data.days_on_leave}</td>
                                <td className='table-body px-2'>{data.leave_type === 'vl' ? "Vacation Leave" : "Emergency/Sick Leave"}</td>
                                <td className='table-body px-2 text-center'>
                                    <div className="flex flex-wrap gap-1 justify-center items-center">
                                        {(JSON.parse(data.leave_dates) as string[]).map((date, idx) => (
                                            <div key={idx} className="bg-orange-200 rounded shadow px-2">{formatDate(date)}</div>
                                        ))}
                                    </div>
                                </td>
                                <td className='table-body px-2 text-sm uppercase'>
                                    <p className={data.status === 'Approved' ? 'bg-green-400 rounded text-white' : data.status === 'Pending' ? 'bg-yellow-500 rounded text-white' : 'bg-red-400 rounded text-white'}>
                                        {data.status}
                                    </p>
                                </td>
                                {/* <td className='table-body px-2'>
                                    <div>
                                        <button type="button" className="underline text-blue-500">
                                            view
                                        </button>
                                    </div>
                                </td> */}
                            </tr>
                        ))  : Array.from({length : 3}).map((_, index) => (
                            <tr key={index}>
                                {[...Array(5)].map((_, colIndex) => (
                                    <td key={colIndex} className='table-body'>
                                        <div className="table-loading bg-gray-200"></div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default EmpLeaveDetails;